import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ShowTradeByIdComponent} from '../issuer-mapping/show-trade-by-id/show-trade-by-id.component';
import {SelectionModel} from '@angular/cdk/collections';
import {SenatorNoGvKeyConfirmation} from '../../../../api/models/senator-no-gv-key-confirmation';
import {SenatorCompany} from '../../../../api/models/senator-company';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SenatorQualityGateType} from '../../../../api/models/senator-quality-gate-type';
import {SenatorQualityGateService} from '../../../../api/services/senator-quality-gate.service';
import {SenatorService} from '../../../../api/services/senator.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {SenatorQualityGateFilterModel} from '../../../../api/models/senator-quality-gate-filter-model';
import {SenatorTrades} from '../../../../api/models/senator-trades';
import {SenatorRecentlyMergedAssetClassesTradesService} from '../../../../api/services';

@Component({
  selector: 'app-recently-merged-assest-classes',
  templateUrl: './recently-merged-asset-classes.component.html',
  styleUrls: ['./recently-merged-asset-classes.component.css']
})
export class RecentlyMergedAssetClassesComponent implements OnInit, AfterViewInit {

  @ViewChild(ShowTradeByIdComponent)
  showTradeById: ShowTradeByIdComponent;
  selection = new SelectionModel<SenatorNoGvKeyConfirmation>(true, []);

  twoIQAssetsList: SenatorCompany[] = [];
  // mat table vars
  displayedColumns: string[] = ['filingId', 'transactionDate', 'x2iqAssetName', 'assetClass', 'congressType', 'shares', 'price', 'comments', 'source'];

  tableDataSource: MatTableDataSource<SenatorTrades>;

  selectedProcessedType;
  selectedSearchProcessedType;

  pageSize: number;
  pageNumber: number;
  searchPageNumber: number;
  lastPageNumber: number;
  lastSearchPageNumber: number;
  isSearchingIssuerName: boolean;
  searchString: string;
  lastSearchString: string;
  isLastActionSearch: boolean;

  pageSizeOptions: number[] = [10, 20, 50, 100, 200];
  pageEvent: PageEvent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  loadingData = false;
  assetNamesLoading: boolean;

  hideFilters = false;

  constructor(private qualityGateService: SenatorQualityGateService,
              private _senatorService: SenatorService,
              public snackBar: MatSnackBar, private _fb: FormBuilder,
              private changeDetectorRefs: ChangeDetectorRef,
              private router: Router, private dialog: MatDialog,
              private senatorRecentlyMergedAssetClassesTradesService: SenatorRecentlyMergedAssetClassesTradesService) {
  }

  ngOnInit() {
    this.initVars();
    this.getRecords();
  }

  ngAfterViewInit() {
    if (this.tableDataSource != null) {
      this.tableDataSource.paginator = this.paginator;
      this.tableDataSource.sort = this.sort;
    }
  }

  initVars() {
    this.pageSize = 10;
    this.pageNumber = 1;
    this.searchPageNumber = 1;
    this.lastPageNumber = 1;
    this.lastSearchPageNumber = 1;
    this.selectedProcessedType = 'ALL';
    this.selectedSearchProcessedType = 'ALL';
    this.assetNamesLoading = false;
    this.isSearchingIssuerName = false;
    this.searchString = '';
    this.lastSearchString = '';
    this.isLastActionSearch = false;
  }

  getRecords(value?: string) {
    if (this.isSearchingIssuerName)
      value = this.searchString;
    this.loadingData = true;

    const params: SenatorQualityGateFilterModel = {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
      processedType: 'ALL',
      qualityGateType: null,
      searchByCompanyName: '',

    };
    this.senatorRecentlyMergedAssetClassesTradesService.getSenatorRecentlyMergedAssetClassesTrades(params).subscribe(
      (res: SenatorTrades[]) => {
        this.tableDataSource = new MatTableDataSource<SenatorTrades>(res);
        // console.log('issuerTableDataSource res', res);
      },
      error => {
        this.loadingData = false;
      },
      () => {
        this.loadingData = false;
        this.paginator.pageIndex = this.pageNumber - 1;
        this.paginator.pageSize = this.pageSize;
        this.hideFilters = false;
      }
    );
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });
  }


  onPaginateChange(event: PageEvent) {

    if (event.pageSize != this.pageSize) {
      this.selection.clear();
    }

    if (!this.isSearchingIssuerName) {
      //if search removed and paginating
      this.pageNumber = event.pageIndex + 1;
      this.lastPageNumber = this.pageNumber;
      this.pageSize = event.pageSize;
      this.getRecords();
      // console.log('onPaginateChange: event', event);

    } else {
      //if searched something and paginating
      this.pageNumber = event.pageIndex + 1;
      this.lastSearchPageNumber = this.pageNumber;
      this.pageSize = event.pageSize;
      this.getRecords(this.searchString);
    }
  }


}
